import {
    GetResellerAssortedFamiliesInput,
    GetResellerAssortedFamiliesOutput,
    GetResellerReturnTimeWindowsInput,
    GetResellerReturnTimeWindowsOutput,
} from '../types';
import { Logger } from '../utils/logger';
import { HrpsApiClient } from './HrpsApiClient';

export const getResellerReturnTimeWindows = async (
    input: GetResellerReturnTimeWindowsInput
): Promise<GetResellerReturnTimeWindowsOutput> => {
    return await new HrpsApiClient()
        .callHrps('getResellerReturnTimeWindows', input)
        .then((response) => {
            return response.data as GetResellerReturnTimeWindowsOutput;
        })
        .catch((error) => {
            Logger.debug(
                `Error getting reseller return time windows for reseller id: ${input.resellerId}, with error ${error.message}`
            );
            throw error;
        });
};

export const getResellerAssortedFamilies = async (
    input: GetResellerAssortedFamiliesInput
): Promise<GetResellerAssortedFamiliesOutput> => {
    Logger.info('Getting reseller assorted families for reseller ', input.resellerId);
    return await new HrpsApiClient()
        .callHrps('getResellerAssortedFamilies', input)
        .then((response) => {
            Logger.debug(response.data);
            return response.data;
        })
        .catch((error) => {
            Logger.debug(`Error getting reseller assorted families for reseller ${input.resellerId}`, error.message);
            throw error;
        });
};
